import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import selector from './upliftEditor.selector';
import { setSelected } from '../Construction/construction.reducer';

import SelectEdit from '../../components/SelectEdit';

import { availableType } from '../../types/available.types';
import { infoShape } from '../../types/info.types';

class UpliftEditor extends React.Component {
  static propTypes = {
    loaded: PropTypes.bool.isRequired,
    setSelected: PropTypes.func.isRequired,
    available: PropTypes.arrayOf(availableType),
    info: infoShape,
    selected: PropTypes.number,
  }

  static defaultProps = {
    available: [],
    selected: null,
    info: null
  }

  handleUpliftChange = (value) => {
    this.props.setSelected('uplift', value);
  }

  render() {
    return (
      this.props.loaded ? (
        <SelectEdit
          selected={this.props.selected}
          loaded={this.props.loaded}
          title={this.props.translationsData.garage_uplift_and_gateway || 'garage_uplift_and_gateway'}
          info={this.props.info}
          onChange={this.handleUpliftChange}
          options={this.props.available
            .filter(el => el.attributes && (el.attributes.value_cm || el.attributes.value_cm === 0))
            .map((el) => ({
              id: el.id,
              value: `${el.attributes.value_cm}cm`
            }))}
        />
      ) : <SelectEdit loading />
    );
  }
}

const mapDispatchToProps = {
  setSelected
};

export default connect(selector, mapDispatchToProps)(UpliftEditor);
